import { render, staticRenderFns } from "./HouseCity.vue?vue&type=template&id=2471c3a7&"
import script from "./HouseCity.vue?vue&type=script&lang=js&"
export * from "./HouseCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports